import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { getToken, setToken } from '../utils/auth';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import 'react-toastify/dist/ReactToastify.css';


export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    telefono: '',
    contrasena: ''
  });

  const [mostrarContrasena, setMostrarContrasena] = useState(false);

  const validarTelefono = (telefono) => {
    const phoneNumber = parsePhoneNumberFromString(telefono, 'ES'); // Puedes hacer esto dinámico si quieres
    return phoneNumber?.isValid() ?? false;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (value) => {
    setForm((prev) => ({ ...prev, telefono: value }));
  };

  const validarCampos = () => {
    const { nombre, apellidos, email, telefono, contrasena } = form;
    const errores = [];

    if (!nombre.trim()) errores.push('nombre');
    if (!apellidos.trim()) errores.push('apellidos');
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errores.push('email válido');
  if (!telefono || !validarTelefono(telefono)) errores.push('teléfono (formato incorrecto)');
    if (!contrasena || contrasena.length < 4) errores.push('contraseña (mínimo 4 caracteres)');

    return errores;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errores = validarCampos();
    if (errores.length > 0) {
      toast.error(`Faltan por rellenar o revisar: ${errores.join(', ')}`);
      return;
    }

    try {
      const res = await api.post('/auth/register', form);
      setToken(res.data.token);
      toast.success('Cuenta creada con éxito');
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      toast.error('Error al registrarse');
    }
  };

  useEffect(() => {
    if (getToken()) {
      navigate('/dashboard');
    }
  }, []);

  return (
    <main className="login site-width">
      <ToastContainer position="bottom-right" />
      <div className="form-login">
        <h2>Crear cuenta</h2>
        <p>Introduce tus datos para registrarte y empezar a gestionar tus citas.</p>
        <form onSubmit={handleSubmit} className="campos-register">
          
          <div className="label-form">
            <label htmlFor="nombre">Nombre:</label>
            <input name="nombre" value={form.nombre} onChange={handleChange} />
          </div>

          <div className="label-form">
            <label htmlFor="apellidos">Apellidos:</label>
            <input name="apellidos" value={form.apellidos} onChange={handleChange} />
          </div>

          <div className="label-form">
            <label htmlFor="email">Correo electrónico:</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div className="label-form">
            <label htmlFor="telefono">Teléfono:</label>
            <PhoneInput
              country={'es'}
              value={form.telefono}
              onChange={handlePhoneChange}
              placeholder="Teléfono"
            />
          </div>

          <div className="label-form">
            <label htmlFor="contrasena">Contraseña:</label>
            <div className="contrasena-input">
              <input
                type={mostrarContrasena ? 'text' : 'password'}
                name="contrasena"
                placeholder="Contraseña"
                value={form.contrasena}
                onChange={handleChange}
              />
              <button
                type="button"
                tabIndex="-1"
                onClick={() => setMostrarContrasena(!mostrarContrasena)}
              >
                {mostrarContrasena
                  ? <img src='/images/ojo.svg' alt="Ocultar" />
                  : <img src='/images/ojo-cruzado.svg' alt="Mostrar" />}
              </button>
            </div>
          </div>

          <button type="submit" className="boton-iniciar-sesion">Crear cuenta</button>
        </form>
      </div>
    </main>
  );
}
